import { headersTags } from '@/libs/axios'

export default {
  /**
   * @param {String} token
   * @param {Array<Number>} farmerIds
   * @param {String} date
   * @param {Object} params
   * @param {Object} headers
   * @param {null} cancelToken
   * @returns {{headers: {}, method: string, url: string}}
   */
  list(token, farmerIds, date, params = {}, headers = {}, cancelToken = null) {
    return {
      url: '/delivery',
      method: 'GET',
      headers: {
        [headersTags.WITH_RELATIONS]: ['plot', 'crop', 'crop_type', 'crop_packing', 'crop_grade'].join(','),
        Authorization: token,
        ...headers,
      },
      params: {
        date,
        farmer_ids: farmerIds,
        states: ['printed', 'saved'],
        'with-trashed': true,
        ...params,
      },
      ...(cancelToken !== null ? { cancelToken } : {}),
    }
  },
}
